import { Button, Checkbox, Modal, Typography } from 'antd';

import { useClientDuplicateModal } from '@app/components/Modals/ClientDuplicateModal/hooks/useClientDuplicateModal';

import type { FC } from 'react';

import '@app/components/Modals/ClientDuplicateModal/ui/ClientDuplicateModal.scss';

const { Text } = Typography;

interface ClientDuplicateModalProps {
  open: boolean;
  phone: string;
  isMergePossible: boolean;
  onCancel: () => void;
  onOpenClient: () => void;
  onMerge: () => Promise<void>;
}

export const ClientDuplicateModal: FC<ClientDuplicateModalProps> = (props) => {
  const { open, phone, isMergePossible, onCancel, onOpenClient } = props;
  const { isMerging, isDisabled, mergeHandler, setIsDisabled } =
    useClientDuplicateModal(props);

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      centered
      title="Клиент с таким номером уже существует"
      footer={
        isMergePossible ? (
          <>
            <Button onClick={onCancel}>Отменить</Button>
            <Button
              type="primary"
              className="ClientDuplicateModal__button"
              loading={isMerging}
              onClick={mergeHandler}
              disabled={isDisabled}
            >
              Объединить
            </Button>
          </>
        ) : (
          <>
            <Button onClick={onCancel}>OK</Button>
            <Button type="primary" onClick={onOpenClient}>
              Открыть клиента
            </Button>
          </>
        )
      }
    >
      <div className="ClientDuplicateModal">
        <Text>
          В филиале уже существует клиент с номером {phone}.
          {isMergePossible
            ? ' Можно объединить текущую карточку с карточкой существующего клиента.'
            : ' Сохранить текущую карточку с таким же номером невозможно.'}
        </Text>
        {isMergePossible && (
          <Text className="ClientDuplicateModal__warning">
            Перед объединением проверьте номер телефона клиента. Объединение
            клиентов — это необратимая операция.
          </Text>
        )}
        {isMergePossible && (
          <Checkbox
            value={isDisabled}
            onChange={(e) => setIsDisabled(!e.target.checked)}
          >
            Подтверждаю, что телефонный номер клиента указан верно
          </Checkbox>
        )}
      </div>
    </Modal>
  );
};
